var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class LazyLoader extends Component {
    constructor() {
        super('LazyLoader', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('main').on('scroll', () => {
                LazyLoader.checkImageVisibility();
            });
            $(window).on('scroll', () => {
                LazyLoader.checkImageVisibility();
            });
            $('.slide-container').on('scroll', () => {
                LazyLoader.checkImageVisibility();
            });
            LazyLoader.checkImageVisibility();
            this.success();
        });
    }
    static checkImageVisibility() {
        $('.project').each((project, projectIndex) => {
            project.find('.slide').each((slide, slideIndex) => {
                if (slide.viewportPosition().y < $(window).height() && slide.viewportPosition().x < $(window).width()) {
                    this.loadSlide(projectIndex, slideIndex);
                    this.loadSlide(projectIndex, slideIndex + 1);
                    this.loadSlide(projectIndex + 1, slideIndex);
                }
            });
        });
    }
    static get_src(image_data) {
        const srcs = image_data.split(';');
        return devicePixelRatio > 1 && srcs[1] ? srcs[1] : srcs[0];
    }
    static preloadImage(image_data) {
        return __awaiter(this, void 0, void 0, function* () {
            const img = new Image();
            img.src = this.get_src(image_data);
            return new Promise((resolve) => {
                img.onload = () => {
                    resolve();
                };
                img.onerror = () => {
                    resolve();
                };
            });
        });
    }
    static loadSlide(projectIndex, slideIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const image = $('.project').eq(projectIndex).find('.slide').eq(slideIndex).find('.slide-image');
            if (image.length == 0 || image.data('backgroundLoaded') == 'true')
                return;
            const imageURL = this.get_src(image.data('hwBackgroundImage'));
            yield this.preloadImage(imageURL);
            image.css('background-image', `url('${imageURL}')`);
            image.data('backgroundLoaded', 'true');
        });
    }
}
LazyLoader.tolerence = 100;
